import { LoadingState } from "@workspace/blocks/ui";
import { useTranslation } from "../../i18n";
export function ViewerLoadingState({ title }: { title?: string }) {
	const { t } = useTranslation();
	return (
		<div className="absolute inset-0 z-20 flex items-center justify-center bg-muted/95 p-6">
			<LoadingState label={t("viewer.loading")}>
				{title && <span className="text-sm text-muted-foreground">{title}</span>}
			</LoadingState>
		</div>
	);
}
